import { ConfigMurucaSearchLayout } from '@net7/boilerplate-muruca';
import searchTranslationFacetsConfig from './search-translations-facets.config';

export default {
  title: 'search#title_translations',
  searchId: 'translation',
  searchConfig: searchTranslationFacetsConfig,
  resourcePath: '/translation',
  facetsTitle: 'search#facets_title',
  totalResultsText: 'search#translations_total',
  filtersTitle: 'search#filters_title',
  grid: 1,
  description: {
    id: 'translation',
    buttonText: 'search#description_button',
    linkText: 'search#description_link',
  },
  sort: {
    label: 'search#sort_title',
    options: [
      // {
      //   value: '_score',
      //   label: 'search#sort_score',
      //   selected: false,
      //   disabled: true,
      // },
      {
        value: 'sort_title_ASC',
        label: 'search#sort_label_asc',
        selected: true,
      },
      {
        value: 'title_ASC',
        label: 'search#sort_asc',
        selected: false,
      },
      {
        value: 'title_DESC',
        label: 'search#sort_desc',
        selected: false,
      },
    ],
  },
  pagination: {
    limit: 5,
    options: [12, 24, 48],
  },
  itemPreview: {
    classes: 'is-vertical',
  },
  fallback: {
    text: 'search#fallback_text',
    button: 'search#fallback_button',
  },
  ko: {
    text: 'search#ko_text',
    button: 'search#ko_button',
  },
} as ConfigMurucaSearchLayout;
